<template>
  <div class="edit-wrap">
    <template v-if="$route.query.type == 'add-card' || $route.query.type =='edit-card'">
      <div class="edit-profile-wrap emb-card pa-4">
        <div class="card-info">
          <h4 v-if="$route.query.type =='add-card'">{{cardFormSection.Title}}</h4>
          <h4 v-else>{{cardFormSection.Edit_Card_Title}}</h4>
          <v-form ref="form" v-model="valid">
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg6 xl6>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md8 lg8 xl8>
                    <v-text-field
                      v-model="cardNumber"
                      :label="cardFormSection.Card_Number_Placeholder"
                      :rules="inputRules.basictextRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4>
                    <v-text-field
                      v-model="cvv"
                      :label="cardFormSection.CVV_Placeholder"
                      :rules="inputRules.basictextRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-text-field
                      v-model="cardName"
                      :label="cardFormSection.Card_Name_Placeholder"
                      :rules="inputRules.basictextRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12 pb-0>
                    <label class="text-muted">{{cardFormSection.Expiry_Date_Label}}</label>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4>
                    <v-select
                      v-model="selectedMonth"
                      :items="month"
                      :label="cardFormSection.Month_Placeholder"
                      :rules="inputRules.basictextRules"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4>
                    <v-select
                      v-model="selectedYear"
                      :items="year"
                      :label="cardFormSection.Year_Placeholder"
                      :rules="inputRules.basictextRules"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-btn
                      class="accent mx-0 mb-4"
                      @click.stop.prevent="saveData"
                    >{{cardFormSection.Button_Label}}</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- <v-flex xs12 sm12 md6 lg6 xl6 card-bg edit-profile hidden-md-and-down></v-flex> -->
            </v-layout>
          </v-form>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import gettingRestClientObject from "../../../services/utils/cms-helper";
import VueMoment from "vue-moment";
import moment from "moment-timezone";

Vue.use(VueMoment, {
  moment
});
export default {
  data() {
    return {
      cmsRequestFunctions: null,
      cardFormSection: "",
      cardNumber: "",
      cvv: "",
      cardName: "",
      selectedMonth: null,
      selectedYear: null,
      valid: false,
      inputRules: {
        basictextRules: [v => !!v || "This field should not be empty"]
      },
      month: [
        "January",
        "Febuary",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      year: [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027]
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getData();
  },
  methods: {
    saveDetails() {
      this.$refs.form.validate();
      if (this.valid == true) {
        this.$snotify.success("Your account Information Updated succesfully", {
          closeOnClick: false,
          pauseOnHover: false,
          timeout: 1000,
          showProgressBar: false
        });
        setTimeout(() => {
          this.$router.push({ path: "/account/profile" });
        }, 50);
      }
    },
    getData: function() {
      var self = this;

      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "14 Add Credit Card/14 Add Credit Card/14 Add Credit Card.ftl",
        lang: language,

        successCallback: function(response) {
          var res = response.data;
          if (res.area_List) {
            var cardInfoArea = self.cmsRequestFunctions.pluck(
              "Add_Card_Info_Section",
              res.area_List
            );
            self.cardFormSection = self.cmsRequestFunctions.getAllMapData(
              cardInfoArea[0].component
            );
          }
        },
        errorCallback: function(error) {
          console.log(error);
        }
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    saveData: async function() {
      let requestedDate = moment(String(new Date())).format(
        "YYYY-MM-DDThh:mm:ss"
      );
      var sendingRequest = {
        type: "Card Information",
        keyword1: this.cardNumber,
        keyword2: this.cvv,
        keyword3: this.cardName,
        keyword4: this.selectedMonth,
        keyword5: this.selectedYear,
        date1: requestedDate
      };
      let responseObject = await this.cmsRequestFunctions.cmsFormData(
        sendingRequest
      );
      try {
        let insertID = Number(responseObject);
        console.log(insertID);
        this.cardNumber = "";
        this.cvv = "";
        this.cardName = "";
        this.selectedMonth = "";
        (this.selectedYear = ""),
          this.$alertify.success(
            "Your account Information Updated succesfully"
          );
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>